import { render } from "./MainBestSellingAndLessSoldProductReport.vue?vue&type=template&id=554303c8&scoped=true"
import script from "./MainBestSellingAndLessSoldProductReport.vue?vue&type=script&lang=js"
export * from "./MainBestSellingAndLessSoldProductReport.vue?vue&type=script&lang=js"

import "./MainBestSellingAndLessSoldProductReport.vue?vue&type=style&index=0&id=554303c8&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554303c8"]])

export default __exports__